import {
    AUTHENTICATING_ELOQUA_REQUEST, AUTHENTICATING_ELOQUA_SUCCEDDED, AUTHENTICATING_ELOQUA_FAILED,
    FETCHING_ELOQUA_MASTER_CONFIG_REQUEST, FETCHING_ELOQUA_MASTER_CONFIG_SUCCEDDED, FETCHING_ELOQUA_MASTER_CONFIG_FAILED,
    UPDATING_ELOQUA_REQUEST, UPDATING_ELOQUA_SUCCEDDED, UPDATING_ELOQUA_FAILED,
  SYNCHRONISING_ELOQUA_REQUEST, SYNCHRONISING_ELOQUA_SUCCEDDED, SYNCHRONISING_ELOQUA_FAILED,
  FETCHING_ELOQUA_SYNC_DETAILS_REQUEST, FETCHING_ELOQUA_SYNC_DETAILS_SUCCEDDED, FETCHING_ELOQUA_SYNC_DETAILS_FAILED,
} from '../../actions/actionTypes.jsx';

const initialState = {
  changes: {
    saving: false,
    error: null
  },
  authentication: {
    authenticating: false,
    error: null
  },
  config: {
    loading: false,
    item: null,
    error: null
  },
  synchronisation: {
    synchronising: false,
    error: null
  },
  deactivation: {
    deactivating: false,
    error: null
  }
};

function eloquaReducer(state = initialState, action) {
  switch (action.type) {
    case AUTHENTICATING_ELOQUA_REQUEST:
      return Object.assign({}, state, {
        ...state,
        authentication: {
          authenticating: true,
          error: null
        }
      })
    case AUTHENTICATING_ELOQUA_SUCCEDDED:
      return Object.assign({}, state, {
        ...state,
        authentication: {
          authenticating: false,
          error: null
        }
      })
    case AUTHENTICATING_ELOQUA_FAILED:
      return Object.assign({}, state, {
        ...state,
        authentication: {
          authenticating: false,
          error: action.payload
        }
      }) 

    case FETCHING_ELOQUA_MASTER_CONFIG_REQUEST:
      return Object.assign({}, state, {
        ...state,
        config: {
          loading: true,
          error: null
        }
      })
    case FETCHING_ELOQUA_MASTER_CONFIG_SUCCEDDED:
      return Object.assign({}, state, {
        ...state,
        config: {
          loading: false,
          item: action.payload,
          error: null
        }
      })
    case FETCHING_ELOQUA_MASTER_CONFIG_FAILED:
      return Object.assign({}, state, {
        ...state,
        config: {
          loading: false,
          item: null,
          error: action.payload
        }
      }) 
    
    case UPDATING_ELOQUA_REQUEST:
      return Object.assign({}, state, {
        ...state,
        changes: {
          saving: true,
          error: null
        }
      })
    case UPDATING_ELOQUA_SUCCEDDED:
      return Object.assign({}, state, {
        ...state,
        changes: {
          saving: false,
          error: null
        }
      })
    case UPDATING_ELOQUA_FAILED:
      return Object.assign({}, state, {
        ...state,
        changes: {
          saving: false,
          error: action.payload
        }
      })
    case SYNCHRONISING_ELOQUA_REQUEST:
      return Object.assign({}, state, {
        ...state,
        synchronisation: {
          synchronising: true,
          error: null
        }

      })
    case SYNCHRONISING_ELOQUA_SUCCEDDED:
      return Object.assign({}, state, {
        ...state,
        synchronisation: {
          synchronising: false,
          error: null
        }
      })
    case SYNCHRONISING_ELOQUA_FAILED:
      return Object.assign({}, state, {
        ...state,
        synchronisation: {
          synchronising: false,
          error: action.payload
        }
      })

    case FETCHING_ELOQUA_SYNC_DETAILS_REQUEST:
      return Object.assign({}, state, {
        ...state,
        synchronisation: {
          error: null
        }

      })
    case FETCHING_ELOQUA_SYNC_DETAILS_SUCCEDDED:
      return Object.assign({}, state, {
        ...state,
        synchronisation: {
          synchronising: action.payload.syncInProgress,
          error: null
        }
      })
    case FETCHING_ELOQUA_SYNC_DETAILS_FAILED:
      return Object.assign({}, state, {
        ...state,
        synchronisation: {
          error: action.payload
        }
      }) 

    default:
      return state;
  }
}

export { eloquaReducer };